import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { PollTemplateForPreview } from "../poll-templates.type";

@Component({
    selector: "poll-template-element",
    templateUrl: "./poll-template-element.component.html",
    styleUrls: ["./poll-template-element.component.scss", "./../poll-templates.component.scss"],
    providers: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PollTemplateElementComponent {

    @Input() template: PollTemplateForPreview
    @Input() isSelected: boolean;
    @Input() positionClass: 'first' | 'last';

    @Input() searchTerm: string;

    @Output() onSelectTemplate = new EventEmitter<PollTemplateForPreview>();
    
    constructor(
    ){}

    select(template: PollTemplateForPreview){
        this.onSelectTemplate.emit(template);
        this.isSelected = true;
    }

}